// extracted by mini-css-extract-plugin
export default {"alertOuter":"VoucherView_alertOuter__XfCAL","customCodeAlert":"VoucherView_customCodeAlert__rgqHo"};